import { Component } from '@angular/core';
import { AuthService } from 'app/services/auth.service';

@Component({
    selector: 'forgot-password',
    templateUrl: 'forgotPassword.component.html',
    styleUrls: ['userViews.scss', 'forgotPassword.component.scss']
})

export class ForgotPasswordComponent {
    public email: string;
    public isWaiting: boolean;
    public emailSent: boolean;

    constructor(private authService: AuthService) { }

    public async recover() {
        this.isWaiting = true;
        if (await this.authService.sendPasswordResetEmail(this.email)) {
            this.emailSent = true;
        }

        this.isWaiting = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/user/forgotPassword.component.ts